import { render, staticRenderFns } from "./ListServices.vue?vue&type=template&id=6a4a9584&scoped=true"
import script from "./ListServices.vue?vue&type=script&lang=js"
export * from "./ListServices.vue?vue&type=script&lang=js"
import style0 from "./ListServices.vue?vue&type=style&index=0&id=6a4a9584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a9584",
  null
  
)

export default component.exports